export default "__VITE_ASSET__DPX3oFyy__"